import { createFileRoute } from "@tanstack/react-router";
import MakeModelPage from "@/pages/MakeModelPage";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/cars/$make/$model/$fuel/")({
  head: ({ params }) => routeHead("/de/cars/$make/$model/$fuel/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MakeModelPage />
  );
}
